import { axiosCitajteo } from "../../axios/citajteo_axios";
import { DlGroup } from "type/dl_group/dl_group.type";
import { GroupSearchOptions } from "constant/dl_group/dl_group.constant";

export const groupGet = async (
  id: string,
  searchBy: string = "id"
): Promise<any> => {
  let result: DlGroup | null = null;
  let response: any;
  try {
    response = await axiosCitajteo.get(`dl-group/${id}?searchBy=${searchBy}`);
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
  }

  return result;
};

export type GroupSearchParams = Partial<
  Record<GroupSearchOptions, number | string>
>;

const groupResponseFormat = (unit: any): any => {
  const result = { ...unit };

  return result;
};

export const groupSearch = async (
  searchParams?: GroupSearchParams
): Promise<any> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosCitajteo.post(`dl-group/search`, searchParams ?? {});
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
    result.items = result.items.map((item: any) => groupResponseFormat(item));
  }

  return result;
};
